<template>

  <div class="unique-plan-item">
        <span class="top-label"></span>
        <h4>
            <span class="title-label"></span>
            <span>{{ currentPlan.title }}</span>
        </h4>
        <p class="price-des">
            <template v-if="free">
                <span>{{ $t( 'homepage.basic_free_des' ) }}</span>
            </template>
        </p>
        <p class="basic-des">
            <span>{{ $t( 'homepage.basic_des' ) }}</span>
        </p>
        <div class="select-wrap flex">
            <select-primary :options="cycleFrequencyOptions" v-model="currentPlanProductIndex" class="plan-select"></select-primary>
            <button
                class="ui-button primary-button short-button subscription-button"
                @click="goSubscription"
                v-if="showButton"
                ga-label="Get Basic Now">
                    {{ $t('homepage.get_start_now') }}
            </button>
        </div>
        <p class="plan-des">
            <span>{{ currentPlan.description }}</span>
        </p>
        <ul class="bottom-content flex">
            <li>
                <i class="icon-check"></i>
                <span v-html="$options.filters.planHistory(currentPlan)"></span>
            </li>
            <li>
                <i class="icon-check"></i>
                <span v-html="$options.filters.planCamera(currentPlan)"></span>
            </li>
            <li v-if="!FEATURE('dashboard.used_space')">
                <i class="icon-check"></i>
                <span v-html="$options.filters.planCapacity(currentPlan)"></span>
            </li>
        </ul>
  </div>

</template>

<script>
import selectPrimary from '@/basic/selectPrimary';
import { orderedProductInfo } from '@/api/plan';
import {config} from 'CONFIG';
import router from '@/router';
import user from '@/api/user';

export default {
    components: {

        selectPrimary

    },
    props: {

        plan: Object

    },

    data () {

        return {

            currentPlanProductIndex: 0,
            config

        };

    },

    computed: {
        currentPlan () {

            return this.plan.products[ this.currentPlanProductIndex ];

        },

        cycleFrequencyOptions () {

            let arr = [];

            this.plan.products.forEach(( product, index ) => {

                arr.push({
                    value: index,
                    label: this.$tc( `cycle.${product.cycle.standard.interval.unit}`, product.cycle.standard.interval.frequency, {

                        count: product.cycle.standard.interval.frequency

                    })
                });

            });

            return arr;

        },

        userStatus () {

            return this.$store.state.user.status;

        },
        showButton () {

            return this.userStatus === 'logined' || this.userStatus === 'notLogined';

        },

        free () {

            return Number( this.currentPlan.cycle.standard.salePrice ) === 0;

        }
    },

    methods: {
        async goSubscription () {

            if ( this.userStatus === 'logined' ) {

                try {

                    let sub = await orderedProductInfo();
                    let path = sub ? '/user/update-plan/' : '/user/subscribe-plan/';
                    router.push({ path });

                } catch ( err ) {

                    console.log( err );

                }

            } else {

                user.goToAccountCenter( true );

            }

        }
    },

    watch: {
        cycleFrequencyOptions: {

            handler ( n ) {

                this.currentPlanProductIndex = n[0].value;

            },
            immediate: true

        }
    }
};

</script>

<style scoped lang="less">
.unique-plan-item {
    padding: 50px 0 60px !important;
    margin: 0 auto;
    max-width: 1200px;
    border-radius: 18px;
    background-color: #fff;
    position: relative;
    text-align: center;
    .top-label {
        background-color: #4AA5FF;
        display: block;
        height: 3px;
        position: absolute;
        top: 0;
        width: calc(100% - 0.3rem);
        left: 50%;
        -webkit-transform: translateX(-50%);
        transform: translateX(-50%);
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        border-radius: 1rem;
    }
    h4 {
        font-size: 0;
        font-weight: 700;
        width: 870px;
        margin: 0 auto;
        padding-bottom: 30px;
        border-bottom: 1px solid #eee;
        span {
            font-size: 0.24rem;
        }
    }
    span {
        vertical-align: middle;
    }
    .title-label{
        display: inline-block;
        border-radius: 100%;
        width: 10px;
        height: 10px;
        margin-right: 0.16rem;
        background-color: #4AA5FF;
    }
    .price-des {
        font-weight: 500;
        font-size: 0.28rem;
        margin-top: 50px;
    }
    .basic-des {
        font-size: 0.18rem;
        font-weight: 400;
        margin-top: 0.16rem;
    }
    .plan-des {
        font-size: 0.16rem;
        font-weight: 400;
        margin-top: 0.2rem;
    }
    .select-wrap {
        margin-top: 30px;
        justify-content: center;
        align-items: center;
        .plan-select {
            margin-right: 30px;
        }
    }
    .bottom-content {
        width: 870px;
        margin: 0 auto;
        margin-top: 50px;
        padding-top: 0.16rem;
        border-top: 1px solid #eee;
        justify-content: center;
        li {
            & + li {
                margin-left: 45px;
            }
            i {
                color: @theme;
                font-size: 0.18rem;
                vertical-align: middle;
                margin-right: .05rem;
            }
            span {
                vertical-align: middle;
                font-size: 0.16rem;
                /deep/ span {
                    font-weight: 500;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/uniquePlanItem.vue